function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DAcRegistrationForm.css';
import React, { useEffect, useState } from 'react';
import { find, reduce, isEmpty } from 'lodash';
import { get, getDictionaryItem } from '../../../utils';
import { IconPlusCircle, IconDelete } from '../../atoms/Icons/';
import { Checkbox, TextInput, Select, RadioButtons } from '../../DAcApplication/components/StepsTemplates/components/FormFields';
import { GetLookupById, uploadConsent } from '../../DAcApplication/components/actions';
import Loader from '../../DAcApplication/components/loader';
import { getSessionId } from '../../DAcApplication/utils';
import { GetInvitationCodes } from '../../DAcApplication/components/actions';
const DacRegisterForm = _ref => {
  let {
    dictionary,
    configuration,
    apiConfig,
    redirectToBanner,
    rtl
  } = _ref;
  const relationshipId = 'EA96BE9E75D8D3D690AEDAE5040EDF2F';
  const initialContext = {
    firstName: {
      value: '',
      name: 'firstName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'firstName'),
      required: true,
      isParent: true,
      valid: false
    },
    lastName: {
      value: '',
      name: 'lastName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'lastName'),
      required: true,
      isParent: true,
      valid: false
    },
    email: {
      value: '',
      name: 'email',
      type: 'email',
      label: getDictionaryItem(dictionary, 'emailAddress'),
      required: true,
      isParent: true,
      valid: false
    },
    marketingOptIn: {
      value: false,
      name: 'marketingOptIn',
      type: 'email',
      label: get(configuration, 'acceptEmailOrMessagesText.jss.value'),
      required: false,
      valid: false
    },
    privacyPolicy: {
      value: false,
      name: 'privacyPolicy',
      type: 'checkbox',
      label: get(configuration, 'acceptDGDPRAndPrivacyPolicyText.jss.value'),
      required: true,
      valid: false
    },
    familyApplication: {
      value: false,
      name: 'familyApplication',
      label: get(configuration, 'sectionTile.jss.value'),
      required: false,
      options: [{
        lookupId: false,
        name: {
          ar: getDictionaryItem(dictionary, 'no'),
          en: getDictionaryItem(dictionary, 'no')
        }
      }, {
        lookupId: true,
        name: {
          ar: getDictionaryItem(dictionary, 'yes'),
          en: getDictionaryItem(dictionary, 'yes')
        }
      }]
    }
  };
  const siblingsContextInitial = {
    firstName: {
      value: '',
      name: 'firstName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'firstName'),
      required: true,
      valid: false
    },
    lastName: {
      value: '',
      name: 'lastName',
      type: 'text',
      label: getDictionaryItem(dictionary, 'lastName'),
      required: true,
      valid: false
    },
    relation: {
      value: '',
      name: 'relation',
      type: 'select',
      label: getDictionaryItem(dictionary, 'relationship'),
      required: true,
      valid: false
    }
  };
  const {
    apiKey,
    apiUrl
  } = apiConfig;
  const sessionId = getSessionId('');
  const [context, setContext] = useState(initialContext);
  const [siblingsContext, setSiblingsContext] = useState([]);
  const [relationshipList, setRelationshipList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [validateParentRule, setValidateRequireRule] = useState(false);
  const updateContext = data => {
    setContext(state => _objectSpread(_objectSpread({}, state), data));
  };
  const updateSiblingConext = (data, key) => {
    setSiblingsContext(siblingsContext.map((item, index) => {
      if (index == key) return _objectSpread(_objectSpread({}, item), data);
      return item;
    }));
  };
  const addSiblingItem = () => {
    setSiblingsContext(state => [...state, siblingsContextInitial]);
  };
  const removeSiblingItem = index => {
    setSiblingsContext(state => state.filter((item, i) => index != i));
  };
  const formSubmit = async e => {
    e.preventDefault();
    setSubmitError('');
    setSubmitting(true);
    const data = await collectData();
    const {
      Success = false,
      error
    } = await GetInvitationCodes({
      apiKey,
      apiUrl,
      sessionId
    }, data);
    setSubmitting(false);
    console.log(Success, error);
    if (!isEmpty(error)) {
      const errorMessage = rtl && error.ar ? error.ar : error.en || '';
      setSubmitError(errorMessage.replaceAll(',', '\n'));
      return;
    }
    if (Success) {
      await uploadConsent({
        apiKey,
        sessionId
      }, {
        email: data.submitter.email,
        firstName: data.submitter.firstName,
        lastName: data.submitter.lastName,
        url: window.location.href,
        consent: data.marketingOptIn
      });
      redirectToBanner(true, context['email'].value);
    }
  };
  const collectData = () => {
    const dataMapping = [{
      name: 'submitter',
      fields: ['firstName', 'lastName', 'email'],
      isChildrens: true
    }, {
      name: 'familyApplication',
      fields: ['familyApplication']
    }, {
      name: 'marketingOptIn',
      fields: ['marketingOptIn']
    }, {
      name: 'privacyPolicy',
      fields: ['privacyPolicy']
    }, {
      name: 'applicants',
      fields: ['firstName', 'lastName', 'relation'],
      isArray: true
    }];
    const submitData = reduce(dataMapping, (data, _ref2) => {
      let {
        name,
        fields,
        isArray,
        isChildrens
      } = _ref2;
      if (!isArray) {
        data[name] = {};
        console.log(name, fields);
        fields.forEach(fieldName => {
          console.log(fieldName, data);
          return isChildrens ? data[name][fieldName] = context[fieldName].value : data[fieldName] = context[fieldName].value;
        });
      } else {
        data[name] = [];
        siblingsContext.forEach(siblingGroupField => {
          const siblingGroupData = reduce(fields, (acc, fieldName) => {
            acc[fieldName] = siblingGroupField[fieldName].value;
            return acc;
          }, {});
          console.log(siblingGroupData);
          data[name].push(siblingGroupData);
        });
      }
      return data;
    }, {});
    console.log(submitData);
    submitData.otherDetails = {
      hiddenCity: '',
      hiddenCountryCode: '',
      hiddenNetwork: '',
      hiddenTimeZone: '',
      utmCampaign: '',
      utmContent: '',
      utmMedium: '',
      utmSource: '',
      utmTerm: '',
      sourceURL: ''
    };
    return submitData;
  };
  useEffect(() => {
    async function fetchRelationship() {
      const response = await GetLookupById({
        apiKey,
        apiUrl,
        sessionId,
        lookupid: relationshipId
      });
      setRelationshipList(response || []);
    }
    fetchRelationship();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const isInvalidParent = find(context, _ref3 => {
      let {
        required,
        valid,
        isParent = false
      } = _ref3;
      return required && isParent && !valid;
    });
    setValidateRequireRule(!isInvalidParent);
  }, [context]);
  useEffect(() => {
    if (validateParentRule) {
      const invalidFieldChildren = siblingsContext.find(siblingGroupField => find(siblingGroupField, _ref4 => {
        let {
          required,
          valid
        } = _ref4;
        return required && !valid;
      }));
      const invalidField = find(context, _ref5 => {
        let {
          required,
          valid
        } = _ref5;
        return required && !valid;
      });
      setDisableSubmit(!!invalidField || !!invalidFieldChildren);
    } else {
      setDisableSubmit(true);
    }
  }, [validateParentRule, siblingsContext, context]);
  useEffect(() => {
    if (context.familyApplication.value) {
      addSiblingItem();
    } else {
      setSiblingsContext([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.familyApplication.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, /*#__PURE__*/React.createElement("form", {
    className: "dac-login-form",
    onSubmit: formSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap  `
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['firstName'], {
    updateContext: updateContext,
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap  `
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['lastName'], {
    updateContext: updateContext,
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap  `
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['email'], {
    updateContext: updateContext,
    rtl: rtl
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12  "
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap radio-field`
  }, /*#__PURE__*/React.createElement(RadioButtons, _extends({}, context['familyApplication'], {
    updateContext: updateContext,
    rtl: rtl,
    isBoolean: true
  })))), context.familyApplication.value == '1' && /*#__PURE__*/React.createElement("div", {
    className: " col-12 "
  }, /*#__PURE__*/React.createElement("p", {
    className: "fields-group-title"
  }, " ", getDictionaryItem(dictionary, 'familyMemberDetails')), siblingsContext.map((prop, index) => {
    return /*#__PURE__*/React.createElement(SiblingFieldList, {
      key: index,
      context: prop,
      relationshipList: relationshipList,
      dataKeyProperty: index,
      updateContext: updateSiblingConext,
      removeSiblingItem: removeSiblingItem,
      rtl: rtl,
      title: getDictionaryItem(dictionary, 'memberDetails')
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary dac-add-btn",
    onClick: e => {
      e.preventDefault();
      addSiblingItem();
    }
  }, /*#__PURE__*/React.createElement(IconPlusCircle, null), /*#__PURE__*/React.createElement("span", null, getDictionaryItem(dictionary, 'addMember'))))), validateParentRule && /*#__PURE__*/React.createElement("div", {
    className: "col-12 group-checkbox"
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['marketingOptIn'], {
    updateContext: updateContext,
    rtl: rtl
  })), /*#__PURE__*/React.createElement(Checkbox, _extends({}, context['privacyPolicy'], {
    updateContext: updateContext,
    rtl: rtl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dac-login-form__submit-wrapper col-12 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-failed-wrap"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary dac-login-form__submit dac-login-btn",
    type: "submit",
    disabled: disableSubmit
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: submitting ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'registerNow')), submitting ? /*#__PURE__*/React.createElement(Loader, null) : false), submitError && /*#__PURE__*/React.createElement("b", {
    className: "request-failed"
  }, submitError))))));
};
const SiblingFieldList = _ref6 => {
  let {
    context,
    updateContext,
    rtl,
    relationshipList,
    dataKeyProperty,
    removeSiblingItem,
    title
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", {
    className: "row dac-login-form__inputs fields-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "fields-group-subtitle"
  }, title, " ", dataKeyProperty + 1, /*#__PURE__*/React.createElement("span", {
    className: "divider"
  }), /*#__PURE__*/React.createElement("span", {
    onClick: () => removeSiblingItem(dataKeyProperty),
    className: "dac-remove-btn"
  }, /*#__PURE__*/React.createElement(IconDelete, null)))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap`
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['firstName'], {
    updateContext: newContext => updateContext(newContext, dataKeyProperty),
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap `
  }, /*#__PURE__*/React.createElement(TextInput, _extends({}, context['lastName'], {
    updateContext: newContext => updateContext(newContext, dataKeyProperty),
    rtl: rtl,
    onlyLetter: true
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md-6 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: `form-elements-wrap `
  }, /*#__PURE__*/React.createElement(Select, _extends({}, context['relation'], {
    updateContext: newContext => updateContext(newContext, dataKeyProperty),
    rtl: rtl,
    options: relationshipList,
    isString: true
  })))));
};
export default DacRegisterForm;
const commonStyles = "c1k0dmwr";
const ltrStyles = "ldz9ma7";
const rtlStyles = "r8w2h5x";